<ziro-fieldset-header [legend]="'tkey;shared.dnWizard.dnDetails.ldapDetails.header'">
  <ziro-text [fieldId]="'e164Number'"></ziro-text>
  <ziro-text [fieldId]="'extension'"></ziro-text>
</ziro-fieldset-header>
